import { Input } from '@globalmed/atlas-ui';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styles from './PocTab.module.css';
import { TCreateInstitutionForm } from '../../schema';
import { LocationFields } from '@/components/LocationFields';
import { PhoneField } from '@/components/PhoneField';

/**
 * POC (point of contact) tab of the Create Institution modal.
 * @returns PocTab component.
 */
export const PocTab = () => {
  const { t } = useTranslation();
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<TCreateInstitutionForm>();

  return (
    <div className={styles.flexColumn}>
      <Controller
        name="pocSettings.name"
        control={control}
        render={({ field, fieldState }) => (
          <Input
            label={t('common.name')}
            placeholder={t('admin-panel.pocNamePlaceholder')}
            width="100%"
            disabled={isSubmitting}
            {...field}
            value={field.value ?? ''}
            isError={!!fieldState.error?.message}
            message={t(fieldState.error?.message ?? '')}
            required
          />
        )}
      />
      <Controller
        name="pocSettings.title"
        control={control}
        render={({ field, fieldState }) => (
          <Input
            label={t('admin-panel.pocTitleLabel')}
            placeholder={t('admin-panel.pocTitlePlaceholder')}
            width="100%"
            disabled={isSubmitting}
            {...field}
            value={field.value ?? ''}
            isError={!!fieldState.error?.message}
            message={t(fieldState.error?.message ?? '')}
            required
          />
        )}
      />
      <Controller
        name="pocSettings.email"
        control={control}
        render={({ field, fieldState }) => (
          <Input
            label={t('common.email')}
            placeholder={t('admin-panel.pocEmailPlaceholder')}
            width="100%"
            disabled={isSubmitting}
            isError={!!fieldState.error}
            message={t(fieldState.error?.message ?? '')}
            required
            {...field}
          />
        )}
      />
      <PhoneField name="pocSettings.phone" disabled={isSubmitting} required />
      <div className={styles.row}>
        <LocationFields
          nameCountry="pocSettings.country"
          nameState="pocSettings.state"
          stateLabel="common.state-territory"
        />
      </div>
      <div className={styles.row}>
        <Controller
          name="pocSettings.address1"
          control={control}
          render={({ field, fieldState }) => (
            <Input
              label={t('common.address-line-number', { number: 1 })}
              placeholder={t('common.pocStreetPlaceholder')}
              width="100%"
              disabled={isSubmitting}
              {...field}
              value={field.value ?? ''}
              isError={!!fieldState.error?.message}
              message={t(fieldState.error?.message ?? '')}
            />
          )}
        />
        <Controller
          name="pocSettings.address2"
          control={control}
          render={({ field, fieldState }) => (
            <Input
              label={t('common.address-line-number', { number: 2 })}
              placeholder={t('common.addressAptLabel')}
              width="100%"
              disabled={isSubmitting}
              {...field}
              value={field.value ?? ''}
              isError={!!fieldState.error?.message}
              message={t(fieldState.error?.message ?? '')}
            />
          )}
        />
      </div>
      <Controller
        name="pocSettings.zip"
        control={control}
        render={({ field, fieldState }) => (
          <Input
            label={t('common.zipCodeLabel')}
            placeholder={t('common.zipCodePlaceholder')}
            width="100%"
            disabled={isSubmitting}
            {...field}
            value={field.value ?? ''}
            isError={!!fieldState.error?.message}
            message={t(fieldState.error?.message ?? '')}
          />
        )}
      />
    </div>
  );
};
